import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-user-registration',
  templateUrl: './admin-user-registration.component.html',
  styleUrls: ['./admin-user-registration.component.scss']
})
export class AdminUserRegistrationComponent implements OnInit {


  navLinks: any[];
  activeLinkIndex = 0;
  constructor(private router: Router) {

    this.navLinks = [
      {
          label: 'Epc Users',
          link: '/inject-solar/admin-user-registration/epc-users',
          index: 0
      },
      {
          label: 'Normal Users',
          link:  '/inject-solar/admin-user-registration/admin-normal-users',
          index: 1
      },
      {
        label: 'Wms Users',
        link:  '/inject-solar/admin-user-registration/admin-wms-users',
        index: 2
      },
      {
        label: 'ZE Users',
        link:  '/inject-solar/admin-user-registration/admin-ze-users',
        index: 3
      },
      {
        label: 'DG Users',
        link:  '/inject-solar/admin-user-registration/admin-dg-users',
        index: 4
      }
  ];
   }

  ngOnInit() {
    this.router.events.subscribe((res) => {
      this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.link === '.' + this.router.url));
  });
  }

}
